module.exports = __webpack_public_path__ + "static/media/rebirth_8.85fc82d2.jpg";